import { scheduleIdle } from '../preload.js';

function getBackgroundImageUrl(element) {
  if (!element) {
    return '';
  }

  const inline = element.style.backgroundImage || window.getComputedStyle(element).backgroundImage;
  const match = /^url\((['"]?)(.*?)\1\)$/.exec(inline || '');
  return match ? match[2] : '';
}

function preloadImage(url) {
  if (!url) {
    return Promise.resolve();
  }

  return new Promise(function (resolve) {
    const image = new Image();
    image.onload = function () { resolve(); };
    image.onerror = function () { resolve(); };
    image.src = url;
    if (image.complete) {
      resolve();
    }
  });
}

export function createHomeController(root, navigateTo, preloader) {
  if (!root) {
    return null;
  }

  const cover = root.querySelector('.home-cover');
  const intro = root.querySelector('.home-intro');

  if (!cover || !intro) {
    return null;
  }

  const coverVideo = cover.querySelector('.home-cover__video');
  const coverCta = cover.querySelector('.home-cover__cta');
  const coverContent = cover.querySelector('.home-cover__content');
  const coverFootnote = cover.querySelector('.home-footnote');
  const coverPiStatement = cover.querySelector('.home-pi-statement');
  const coverBg = cover.querySelector('.home-cover__bg');
  const introBg = intro.querySelector('.home-intro__bg');
  const introReady = preloadImage(getBackgroundImageUrl(introBg));

  let revealRequested = false;

  function resetCoverState() {
    if (coverContent) coverContent.hidden = false;
    if (coverFootnote) coverFootnote.hidden = false;
    if (coverPiStatement) coverPiStatement.hidden = false;
    if (coverBg) coverBg.hidden = false;
    if (coverVideo) {
      coverVideo.style.display = 'none';
      coverVideo.pause();
      try { coverVideo.currentTime = 0; } catch (e) {}
    }
    cover.classList.remove('is-hidden');
    revealRequested = false;
  }

  function startCoverVideo() {
    if (!coverVideo) {
      navigateTo('intro');
      return;
    }

    if (coverContent) coverContent.hidden = true;
    if (coverFootnote) coverFootnote.hidden = true;
    if (coverPiStatement) coverPiStatement.hidden = true;
    if (coverBg) coverBg.hidden = true;
    coverVideo.style.display = 'block';

    try { coverVideo.currentTime = 0; } catch (e) {}
    coverVideo.play().catch(function () {});
  }

  function revealIntro() {
    if (revealRequested) {
      return;
    }
    revealRequested = true;
    introReady.then(function () {
      navigateTo('intro');
    });
  }

  if (coverCta && coverVideo) {
    coverCta.addEventListener('click', function (event) {
      event.preventDefault();
      startCoverVideo();
    });

    coverVideo.addEventListener('timeupdate', function () {
      if (!coverVideo.duration || revealRequested) {
        return;
      }

      if (coverVideo.currentTime >= Math.max(coverVideo.duration - 0.12, 0)) {
        coverVideo.pause();
        revealIntro();
      }
    });

    coverVideo.addEventListener('ended', function () {
      revealIntro();
    });
  }

  return {
    enter: function (route) {
      if (route === 'cover') {
        resetCoverState();
        cover.hidden = false;
        intro.hidden = true;
        intro.classList.remove('is-visible');
        return;
      }

      if (route === 'intro') {
        cover.hidden = true;
        cover.classList.add('is-hidden');
        intro.hidden = false;
        intro.classList.add('is-visible');

        scheduleIdle(function () {
          preloader.preloadSlide(0);
        }, 100);
      }
    },
    leave: function () {
      if (coverVideo) {
        coverVideo.pause();
      }
    }
  };
}
